<template>
    <div :class="classes" @click="toggleEditMode">
        <template v-if="!editMode">
            <CompassSkeleton
                v-if="loading"
                size="x-large"
                :style="{ width: `${componentWidth}px` }"
            />
            <div v-else ref="editSelectValue" :class="valueClasses">
                <span
                    v-if="selectedItem.color"
                    class="edit-select__value-dot"
                    :style="`backgroundColor: ${selectedItem.color}`"
                />
                <span class="typographies-paragraph-medium-regular">
                    {{ selectedItem.label }}
                </span>
            </div>
        </template>
        <CompassSelect
            v-else
            ref="editSelect"
            :size="size"
            :value="selectedValue"
            forceSelectOpen
            @close="editMode = false"
            @update:value="handleValueUpdate"
        >
            <CompassDropdownSelectOption
                v-for="item in items"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                :type="item.color ? 'dot' : 'text'"
                :dotColor="item.color"
            />
        </CompassSelect>
    </div>
</template>
<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: null,
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'medium',
        },
    },
    data() {
        return {
            editMode: false,
            componentWidth: 0,
        };
    },
    computed: {
        selectedItem() {
            return this.items.find((item) => item.selected);
        },
        selectedValue() {
            return this.selectedItem.id;
        },
        classes() {
            return [
                'edit-select',
                `edit-select--${this.size}`,
                this.canEdit ? 'edit-select--editable' : '',
            ];
        },
        valueClasses() {
            return ['edit-select__value', `edit-select__value--${this.size}`];
        },
    },
    watch: {
        editMode() {
            if (this.$refs.editSelectValue) {
                this.setComponentWidth();
            }
            this.$nextTick(() => {
                if (this.$refs.editSelect) {
                    this.$refs.editSelect.$el.querySelector(
                        '.compass-input__inner',
                    ).style.width = `${this.componentWidth}px`;
                }
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.setComponentWidth();
        });
    },
    methods: {
        setComponentWidth() {
            let width = 0;
            const gapSize = 8;

            for (const child of this.$refs.editSelectValue.children) {
                width += child.offsetWidth;
            }

            this.componentWidth = width + gapSize;
        },
        toggleEditMode() {
            if (!this.editMode && this.canEdit) {
                this.editMode = true;
            }
        },
        handleValueUpdate(value) {
            this.$emit('update', value);
            this.editMode = false;
        },
    },
};
</script>
<style scoped lang="scss">
.edit-select {
    border-radius: 2px;
    position: relative;

    &--editable {
        .edit-select__value {
            &:before {
                content: '';
                background: var(--colors-common-background-hover);
                border-radius: 2px;
                bottom: 0;
                display: none;
                left: -4px;
                position: absolute;
                right: -4px;
                top: 0;
                z-index: -1;
            }

            &:hover {
                &:before {
                    display: block;
                }
            }
        }
    }

    &--small {
        &::v-deep {
            .compass-skeleton__line {
                height: var(--spacing-4);
            }
        }
    }

    &__value {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
        min-height: 32px;

        &--small {
            min-height: 24px;
        }

        &-dot {
            border-radius: 50%;
            flex-shrink: 0;
            height: var(--spacing-1);
            width: var(--spacing-1);
        }
    }
}
</style>
